import ActivitiesActionTypes from "./planter.types";

const INITIAL_STATE = {
	// general
	error: null,
	loading: false,
	planters:[],
	tress:[],
};

const PlanterReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case ActivitiesActionTypes.CLEAR_ERROR:
			return {
				...state,
				error: null,
			};
		case ActivitiesActionTypes.FETCH_PLANTER_START:
		case ActivitiesActionTypes.FETCH_PLANTER_TREE_START:
			return {
				...state,
				loading: true,
			};
		case ActivitiesActionTypes.FETCH_PLANTER_TREE_FAILURE:
		case ActivitiesActionTypes.FETCH_PLANTER_FAILURE:
			return {
				...state,
				error: action.payload,
				loading: false,
			};
		case ActivitiesActionTypes.FETCH_PLANTER_SUCCESS: {
			return {
				...state,
				planters: action.payload,
				loading: false,
			};
		}
		case ActivitiesActionTypes.FETCH_PLANTER_TREE_SUCCESS: {
			return {
				...state,
				trees: action.payload,
				loading: false,
			};
		}
		default:
			return state;
	}
};

export default PlanterReducer;
